<template>

    <span class="flex-1 overflow-y-scroll">

        <vue-scroll :ops="scrollOps">

        <ul v-if="Array.isArray(playlists) && playlists.length" class="py-6">

            <li v-for="item in playlists" class="flex flex-row items-center text-theme-main hover:bg-theme-controls3 hover:text-theme-control-label rounded-md pl-2">

                <span class="w-4/5">
                    <span class="">{{ item.name }}</span>
                </span>

                <span class="hover-vis-target relative ml-12 mr-2 w-8 h-8 hover:bg-theme-level2 cursor-pointer rounded-lg hover-vis-trigger text-red-200 hover:text-red-500 self-end" @click.stop="removePlaylist(item.id)">
                    <i class="material-icons w-6 h-6 pl-1 pt-1">delete_forever</i>
                    <span class="absolute px-3 py-1 mb-1 bg-theme-copy3 rounded-lg text-xs text-white text-center z-50
                            hover-vis-target flex-1 w-16
                            transform transition-all duration-200"
                          style="bottom: 100%; left: 50%; transform: translate(-50%, 0);">
                        {{ translate('delete') }}
                        <svg class="absolute text-theme-copy3 w-full h-2"
                             style="top: 100%; left: 0;"
                             x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve">
                            <polygon class="fill-current" points="0,0 127.5,127.5 255,0"></polygon>
                        </svg>
                    </span>
                </span>

            </li>

        </ul>

        <ul v-else class="py-4">
            <li>
                <span class="w-4/5">
                    <span class="text-theme-main">{{ translate('playlists-nolist') }}</span>
                </span>
            </li>
        </ul>

        </vue-scroll>

    </span>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        props: [

            'currentlocale',
            'playlists'

        ],

        data() {

            return {

                scrollOps: this.$root.shared.scrollops

            }

        },

        methods: {

            removePlaylist(playlistId) {

                if(confirm(this.translate('playlists-warning'))) {
                    let itemToRemoveIndex = this.playlists.findIndex(i => i.id === playlistId)

                    axios.get('/' + this.currentlocale + '/playlists/delete/' + playlistId)
                        .then((response) => {
                            this.playlists.splice(itemToRemoveIndex, 1)
                        })
                        .catch((error) => {
                            console.log('ERROR trying to Delete Playlist ID: ' + playlistId + ': ' + error)
                        })
                }
            },

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

        }

    }

</script>
